import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../LabelText';
import CountryCode from './CountryCode';

const Mobile = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);

	const contactFields = useSelector(state => state.contactFields);
	const {mobile} = contactFields;

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('mobile', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					},
					regexp: {
						regexp: /(\d)+/i,
						message: t('手機格式錯誤')
					}
				}
			});
		}
	}, [fv]);

	const onChange = (e) => {
		const value = e.target.value;

		const payload = {
			field: 'mobile',
			value: value
		}

		dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<div className="input-group form-group">
				<CountryCode
					lang={props.lang}
					form_component={form_component}
				/>
				<input
					type="text"
					name="mobile"
					inputMode="numeric"
					placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
					id="mobile"
					className="form-control"
					value={mobile}
					onChange={onChange}
				/>	
			</div>
		</div>
	);
}

export default Mobile;